import React from 'react';
import { Result } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import { COLORS, Title } from 'components';
import PropTypes from 'prop-types';

const ComingSoon = ({ title, height }) => (
  <div style={{
    height,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  }}
  >
    <Result
      icon={<InfoCircleOutlined style={{ color: COLORS.accent }} />}
      title={(<Title level={3} $accent>{title}</Title>)}
    />
  </div>
);

ComingSoon.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

ComingSoon.defaultProps = {
  title: 'Disponible proximamente',
  height: '50vh',
};

export default ComingSoon;
